import classNames from 'classnames/bind';
import { Panel } from 'components/Panel';
import { i18nKeys, useTranslation } from 'locales';
import { useSaveCompanyConfiguration } from 'shared/hooks/use-save-company-configuration';

import type { StepProps } from '../OnBoarding.types';
import styleIdentifiers from './GeneralInfo.module.scss';
import GeneralInfoForm from './GeneralInfoForm';

const styles = classNames.bind(styleIdentifiers);

export default function GeneralInfo({ onValidStep }: StepProps) {
  const { t } = useTranslation();
  const { saveCompanyConfiguration } = useSaveCompanyConfiguration();

  const onSubmit = (data: any) => {
    saveCompanyConfiguration(data, { onSuccess: () => onValidStep() });
  };

  return (
    <div className={styles('general-info')}>
      <Panel title={t(i18nKeys.ONBOARDING[4].TITLE)} className={styles('small')}>
        <GeneralInfoForm onSubmit={onSubmit} />
      </Panel>
    </div>
  );
}
